export const KYC_STATUS = {
  NEW: 0,
  EMAIL_VERIFIED: 6,
  PHONE_VERIFIED: 7,
  BUSINESS_TYPE_SUBMITTED: 13,
  PERSONAL_DATA_SUBMITTED: 14,
  COMPANY_DATA_SUBMITTED: 1,
  DOCUMENT_UPLOADED: 8,
  WAITING_APPROVAL: 3,
  APPROVED: 9,
  NEGOTIATE: 10,
  REQUESTED: 11,
  REJECTED: 4,
  CANCELLED: 5,
  DONE: 2,
  DEACTIVATED: 12
};

export const VERIFICATION_STEP = {
  BUSINESS_TYPE: 1,
  PERSONAL_DATA: 2,
  BUSINESS_DETAILS: 3,
  DOCUMENTS: 4
};

// based on reject reason company_details
export const COMPANY_DETAILS_TYPE = {
  INDUSTRY: 1,
  USAGE_PURPOSE: 2,
  BUSINESS_DESCRIPTION: 3,
  SELLING_PLATFORM: 4,
  BUSINESS_ENTITY: 5,
  PPOB_CONFIRMATION: 6,
  SWITCH_NIK: 7,
  VALID_LINK: 8,
  BUSINESS_TYPE: 9,
  LINK_INACCESIBLE: 10,
  INFO_LINK_INCOMPLETE: 11,
  CONTENT_LINK_UNMATCHED: 12,
  FLIP_ACCOUNT_CONFIRMATION: 13,
  BANK_SETTLEMENT: 14
};

export const COMPANY_DETAILS_TYPE_TEXT = {
  [COMPANY_DETAILS_TYPE.INDUSTRY]: "industry",
  [COMPANY_DETAILS_TYPE.BUSINESS_DESCRIPTION]: "business_description",
  [COMPANY_DETAILS_TYPE.BUSINESS_ENTITY]: "business_entity",
  [COMPANY_DETAILS_TYPE.SELLING_PLATFORM]: "selling_platform",
  [COMPANY_DETAILS_TYPE.PPOB_CONFIRMATION]: "ppob_confirmation",
  [COMPANY_DETAILS_TYPE.SWITCH_NIK]: "switch_nik",
  [COMPANY_DETAILS_TYPE.USAGE_PURPOSE]: "usage_purpose",
  [COMPANY_DETAILS_TYPE.VALID_LINK]: "valid_link",
  [COMPANY_DETAILS_TYPE.BUSINESS_TYPE]: "business_type",
  [COMPANY_DETAILS_TYPE.FLIP_ACCOUNT_CONFIRMATION]: "flip_account_confirmation",
  [COMPANY_DETAILS_TYPE.BANK_SETTLEMENT]: "bank_settlement"
};

export const REJECTED_REASONS_MAPS = {
  IDENTITY_IMAGE: {
    UNMATCH_DATA: 9,
    INVALID: 11,
    NEED_UPLOAD_DIRECTOR_STAFF: 12,
    NOT_UPLOADED: 13
  },
  NIB: {
    INVALID: 8
  },
  NPWP: {
    INVALID: 7
  },
  BUSINESS_CATALOG: {
    IMAGE_NOT_MATCH_LINK: 8
  }
};

export const REJECTED_REASONS_COMPANY_DETAILS_LINK = [
  COMPANY_DETAILS_TYPE.VALID_LINK,
  COMPANY_DETAILS_TYPE.LINK_INACCESIBLE,
  COMPANY_DETAILS_TYPE.INFO_LINK_INCOMPLETE,
  COMPANY_DETAILS_TYPE.CONTENT_LINK_UNMATCHED
];

export const REJECT_REASON_IDENTITY_KTP_REUPLOAD = [
  REJECTED_REASONS_MAPS.IDENTITY_IMAGE.UNMATCH_DATA,
  REJECTED_REASONS_MAPS.IDENTITY_IMAGE.NEED_UPLOAD_DIRECTOR_STAFF,
  REJECTED_REASONS_MAPS.IDENTITY_IMAGE.NOT_UPLOADED
];
